module.exports = __webpack_public_path__ + "assets/menu-arrow.e63f3a3c.svg";